import React from 'react';
import { Diamond, Shield } from 'lucide-react';
import BlurredPrice from './BlurredPrice';

const UltraPremiumDomainCard = ({ domain, price, currency = 'ETH', onRequest }) => {
  return (
    <div className="relative w-full bg-black rounded-lg p-8 min-h-[220px]">
      {/* Gradient & Border overlay */}
      <div className="absolute -inset-px rounded-lg bg-gradient-to-b from-white/10 to-white/5" />
      <div className="absolute -inset-px rounded-lg border border-white/20" />

      {/* Ultra Premium label with white background */}
      <div className="absolute -top-2.5 left-6">
        <div className="px-3 py-1 bg-white border border-white/20 rounded-full">
          <div className="text-xs font-medium text-gray-900 uppercase tracking-wider flex items-center gap-1">
            <Diamond size={10} className="mr-1.5" />
            Ultra Premium
          </div>
        </div>
      </div>

      <div className="relative space-y-6">
        <div>
        <div className="flex items-center gap-2 mb-2">
                <Shield className="w-3.5 h-3.5 text-white" />
                <div className="text-sm text-white uppercase tracking-wider">
                    Ultra Premium Domain
                </div>
                </div>
            {/* Domain Title */}
            <h3 className="text-2xl font-medium text-white">
                {domain}
            </h3>
        </div>

        {/* Price & Request Section */}
        <div className="flex items-center justify-between pt-4 border-t border-white/10">
          <div>
            <div className="text-sm text-white/50">Starting From</div>
            <BlurredPrice 
              price={price} 
              currency={currency} 
              className="text-lg text-white mt-0.5"
            />
          </div>
          <button 
          onClick={() => onRequest(domain)}
          className="px-5 py-2 bg-black border border-white rounded-lg text-white hover:bg-white/10 transition-all duration-300">
            Request
          </button>
        </div>
      </div>
    </div>
  );
};

export default UltraPremiumDomainCard;